window.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.product-gallery').forEach(gallery => {
    Fancybox.bind(gallery.querySelector('.product-gallery-items'), {
      keyboard: true,
      buttons: ['zoom', 'slideShow', 'fullScreen', 'thumbs', 'share', 'close']
    });

    const slider = gallery.querySelector('.swiper');

    const config = typeof(slider.dataset.swiper) !== 'undefined' ? JSON.parse(slider.dataset.swiper) : {};
    config.navigation = {
      nextEl: gallery.querySelector('.product-gallery-next'),
      prevEl: gallery.querySelector('.product-gallery-previous')
    };
    config.pagination = config.pagination || {};
    config.pagination.el = gallery.querySelector('.product-gallery-dots');
    config.pagination.clickable = true;

    const swiper = new Swiper(slider, config);
  });
});